import React from 'react'
import Footer from '../components/Footer/Footer'
import Header from '../components/Header/Header'



const Signup = () => {
    return (
        <>
        <Header signup={true}/>
        <Footer/>
        </>
    )
}

export default Signup
